import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { ICON_CONTAINER_WIDTH, TRANSITION_SETTINGS } from '../config';
export const SidebarMenuItemBadge = styled.div `
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  width: ${pxToRem(6)};
  height: ${pxToRem(6)};
  margin-top: ${pxToRem(4)};
  margin-right: ${pxToRem(4)};
  border-radius: 100%;
  background-color: ${themeGet('colors.blue.500')};
  opacity: 0;
  transform: scale(0.5);

  transition: all ${TRANSITION_SETTINGS};

  ${(props) => props.$show &&
    `
  opacity: 1;
  transform: scale(1);
  `}
`;
export const SidebarMenuItemContainer = styled.button `
  position: relative;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  min-width: ${ICON_CONTAINER_WIDTH};
  color: ${themeGet('colors.text.100')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: transparent;
  transition: all ${TRANSITION_SETTINGS};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.500')};
    transition: color ${TRANSITION_SETTINGS};
  }

  &:focus-visible {
    box-shadow: inset 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
  }

  ${(props) => !props.$active &&
    `
    &:hover {
      background-color: ${themeGet('colors.gray.50')};

      [data-icon="falcon"] {
        color: ${themeGet('colors.gray.800')};
      }
    }
  `}

  ${(props) => props.$active &&
    `
    color: ${themeGet('colors.text.300')};
    background-color: ${themeGet('colors.gray.50')};

    [data-icon="falcon"] {
      color: ${themeGet('colors.text.300')};
    }
  `}

  &:active {
    background-color: ${themeGet('colors.gray.100')};
  }
`;
